import { Typography } from '@material-ui/core/styles/createTypography'

const typography = {
    // fontFamily: ['"Helvetica Neue"', 'Helvetica', 'Arial', 'sans-serif'].join(',')
} as Typography

export { typography }
